export default __webpack_public_path__ + "static/gradient-left-fc77a379a7674a1bf3f280c8d7dcd791.png";